// Lightweight branded loader: the three Brizina mark bars animating up and down,
// filled by ONE continuous gradient spanning all three bars — the exact logo
// gradient (#2BB58A → #4C8DFF → #8B7CFF), so the bars read as the mark's sweep.
// Pure CSS animation (GPU scaleY, staggered); honours prefers-reduced-motion.

import { memo } from 'react';

export const BrizinaLoader = memo(function BrizinaLoader() {
  return (
    <svg className="bz-loader-bars" viewBox="0 0 41 46" aria-hidden="true">
      <defs>
        <linearGradient id="bz-loader-grad" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="41" y2="0">
          <stop offset="0" stopColor="#2BB58A" />
          <stop offset="0.5" stopColor="#4C8DFF" />
          <stop offset="1" stopColor="#8B7CFF" />
        </linearGradient>
      </defs>
      <rect className="bz-loader-bar" x="0" y="0" width="9" height="46" rx="4.5" fill="url(#bz-loader-grad)" />
      <rect className="bz-loader-bar" x="16" y="0" width="9" height="46" rx="4.5" fill="url(#bz-loader-grad)" />
      <rect className="bz-loader-bar" x="32" y="0" width="9" height="46" rx="4.5" fill="url(#bz-loader-grad)" />
    </svg>
  );
});
